import { render, staticRenderFns } from "./incomeLst.vue?vue&type=template&id=0f4fb10f&scoped=true&"
import script from "./incomeLst.vue?vue&type=script&lang=js&"
export * from "./incomeLst.vue?vue&type=script&lang=js&"
import style0 from "./incomeLst.vue?vue&type=style&index=0&id=0f4fb10f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f4fb10f",
  null
  
)

export default component.exports